export const PROMPT_P05 = (sponsorProduct = 'Sikadur-31 CF + Sikagard-705 L') => `
Analyze for POP-OUTS / ALKALI-SILICA REACTION (ACI 221.1R).
Visual indicators: conical craters with aggregate at center, ASR gel (white/yellowish deposits),
map cracking, surface expansion. Pop-out size: small <10mm, medium 10–25mm, large >25mm.
Return ONLY this JSON:
{
  "pathology_id": "p05_popout_asr",
  "pathology_name": { "es": "Pop-outs / Reacción Álcali-Sílice", "en": "Pop-outs / ASR" },
  "norm": "ACI 221.1R",
  "confidence": 80,
  "requires_additional_input": false,
  "diagnosis_type": "popout_only|asr_suspected|asr_confirmed_visual|mixed",
  "popout_size": "small|medium|large",
  "asr_gel_visible": false,
  "map_cracking_present": false,
  "root_cause": { "es": "...", "en": "..." },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": ["1. Pop-outs superficiales: limpiar + relleno con mortero epóxico","2. ASR confirmada: evaluación estructural completa obligatoria","3. Sellador penetrante silano-siloxano para reducir absorción de humedad (frena expansión ASR)","4. Monitoreo con testigos de fisuración cada 6 meses"],
      "en": ["1. Surface pop-outs: clean and fill with epoxy mortar","2. Confirmed ASR: mandatory comprehensive structural assessment","3. Silane-siloxane penetrating sealer to reduce moisture absorption (slows ASR)","4. Monitor with crack gauges every 6 months"]
    },
    "norm_reference": "ACI 221.1R-98; ASTM C856 (petrographic examination)"
  },
  "materials": {
    "generic": { "es": "Mortero epóxico; sellador silano-siloxano penetración profunda", "en": "Epoxy mortar; deep-penetration silane-siloxane sealer" },
    "premium": { "product": "${sponsorProduct}", "brand": "Sika", "note": { "es": "Sikagard-705 L: reducción absorción agua 95% (EN 13580)", "en": "Sikagard-705 L: 95% water absorption reduction (EN 13580)" } }
  },
  "linkedin_draft": { "es": "..." },
  "disclaimer": { "es": "ASR confirmada requiere análisis petrográfico ASTM C856. No diagnosticable definitivamente por imagen.", "en": "Confirmed ASR requires petrographic analysis ASTM C856. Cannot be definitively diagnosed from image alone." }
}`;
